import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { UniqueIdentifier } from "@dnd-kit/core";

/* ---------------- TYPES ---------------- */

interface SortableRow {
  id: UniqueIdentifier;
}

interface SortableTableRowProps {
  row: SortableRow;
  className?: string;
  children: (args: { listeners: any | undefined }) => React.ReactNode;
}

interface DragHandleProps {
  listeners?: any;
  disabled?: boolean;
  reason?: string;
}

/* ---------------- SORTABLE ROW ---------------- */

const SortableTableRow: React.FC<SortableTableRowProps> = ({
  row,
  children,
  className,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: row.id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    background: isDragging ? "#f8fafc" : undefined,
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className={className}
      {...attributes}
    >
      {children({ listeners })}
    </tr>
  );
};

/* ---------------- DRAG HANDLE ---------------- */

const DragHandle: React.FC<DragHandleProps> = ({
  listeners,
  disabled,
  reason,

}) => (
  <i
    className={`ri-draggable ${disabled ? "text-muted" : ""}`}
    style={{
      cursor: disabled ? "not-allowed" : "grab",
      opacity: disabled ? 0.3 : 1,
    }}
    title={disabled ? reason : "Drag to reorder"}

    {...(!disabled ? listeners : {})}
  />
);


export { SortableTableRow, DragHandle };
